import React, { useEffect, useRef, useState } from 'react';
import OvenPlayer from 'ovenplayer';

interface WebRTCPlayerOvenMediaProps {
  streamUrl: string;
}

const WebRTCPlayerOvenMedia: React.FC<{ streamUrl: string }> = ({
  streamUrl,
}: WebRTCPlayerOvenMediaProps) => {
  const playerRef = useRef<HTMLDivElement>(null);
  const playerInstance = useRef<any>(null);
  const [error, setError] = useState<string | null>(null);
  const [retryCount, setRetryCount] = useState(0);
  const retryTimeoutRef = useRef<NodeJS.Timeout>();

  const destroyPlayer = () => {
    if (playerInstance.current) {
      try {
        playerInstance.current.remove(); // destroi instância OvenPlayer
      } catch (e) {
        console.warn('Error removing player:', e);
      }
      playerInstance.current = null;
    }
    if (playerRef.current) {
      playerRef.current.innerHTML = ''; // limpa o container
    }
  };

  const createPlayer = () => {
    if (!playerRef.current) return;

    try {
      const player = OvenPlayer.create(playerRef.current, {
        sources: [
          {
            type: 'webrtc',
            file: `${(window as any)._env_.REACT_APP_OVEN_STREAM_WS}/${streamUrl}`,
            label: 'Live Stream',
          },
        ],
        autoStart: true,
        mute: true,
        volume: 0,
        showLogo: false,
        debug: true,
        webrtcConfig: {
          timeoutMaxRetry: 3,
          reconnectInterval: 2000,
        },
      });

      player.on('error', (err: any) => {
        console.error('Player error:', err);
        setError(`Erro no player: ${err.message || 'Falha na conexão'}`);

        if (retryTimeoutRef.current) {
          clearTimeout(retryTimeoutRef.current);
        }

        const delay = Math.min(10000, 1000 * Math.pow(2, retryCount));
        retryTimeoutRef.current = setTimeout(() => {
          setRetryCount((c) => c + 1);
        }, delay);
      });

      player.on('stateChanged', (state: any) => {
        if (state.newstate === 'playing') {
          setError(null);
          setRetryCount(0);
        }
      });

      playerInstance.current = player;
    } catch (e) {
      console.error('Error creating player:', e);
      setError('Falha ao inicializar o player');
    }
  };

  useEffect(() => {
    if (playerInstance.current) {
      playerInstance.current.load([
        {
          type: 'webrtc',
          file: `${(window as any)._env_.REACT_APP_OVEN_STREAM_WS}/${streamUrl}`,
          label: 'Live Stream',
        },
      ]);
    } else {
      createPlayer();
    }

    return () => {
      if (retryTimeoutRef.current) {
        clearTimeout(retryTimeoutRef.current);
      }
    };
  }, [streamUrl]);

  return (
    <div
      style={{
        position: 'relative',
        width: '800px',
        backgroundColor: '#000',
      }}
    >
      <div ref={playerRef} style={{ width: '100%', height: '100%' }} />
      {error && (
        <div
          style={{
            color: 'red',
            position: 'absolute',
            top: 10,
            left: 10,
          }}
        >
          {error}
        </div>
      )}
    </div>
  );
};

export default WebRTCPlayerOvenMedia;
